import { createSelector } from '@reduxjs/toolkit';
import getAllCategoryInfos from './getAllCategoryInfos';
import { checkCategoryAvailability } from '../utils/ordering/daypartMenuAvailability';
import getOrderDateTimeSelected from './getOrderDateTimeSelected';
import getDayparts from './getDayparts';

export default (id: string) =>
  createSelector(
    [getAllCategoryInfos, getOrderDateTimeSelected, getDayparts],
    (categories, dateTimeSelected, daypartSlots): [boolean, string] => {
      const category =
        categories &&
        Array.isArray(categories) &&
        categories.find(cat => cat.id === id);
      if (!category) return [true, ''];
      return checkCategoryAvailability({
        category,
        dateTimeSelected,
        daypartSlots,
      });
    },
  );
